import { Channel } from "@swivl-mono/types";
import { ButtonColor } from "@swivl-mono/ui";

const paramToChannelMap: Record<string, Channel> = {
  web: Channel.WEB,
  sms: Channel.SMS,
  voice: Channel.VOICE,
  gMB: Channel.GOOGLE_MY_BUSINESS,
  fBM: Channel.FACEBOOK_MESSENGER,
  whatsApp: Channel.WHATSAPP,
};
export interface ChannelColor {
  accent: string;
  bg: string;
  border: string;
  hover: string;
  main: string;
  text: string;
  caret: string;
  buttonColor?: ButtonColor;
}
export interface ChannelColors extends Record<Channel, ChannelColor> { }

export const ChannelColors: ChannelColors = {
  [Channel.WEB]: {
    accent: "#ff7f3a",
    bg: "bg-orange-500",
    border: "",
    hover: "hover:text-orange-500",
    main: "#ff5b02",
    text: "text-orange-500",
    caret: "caret-orange-500",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.SMS]: {
    accent: "#00aaa2",
    bg: "bg-teal-450",
    border: "hover:border-teal-450 focus-visible:border-teal-450",
    hover: "hover:text-teal-450",
    main: "#01cbc0",
    text: "text-teal-450",
    caret: "caret-teal-450",
    buttonColor: ButtonColor.TEAL
  },
  [Channel.VOICE]: {
    accent: "#ffb801",
    bg: "bg-amber-450",
    border: "hover:border-amber-450 focus-visible:border-amber-450",
    hover: "hover:text-amber-450",
    main: "#ffa904",
    text: "text-amber-450",
    caret: "caret-amber-450",
    buttonColor: ButtonColor.YELLOW
  },
  [Channel.GOOGLE_MY_BUSINESS]: {
    accent: "",
    bg: "",
    border: "",
    hover: "",
    main: "",
    text: "",
    caret: "",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.FACEBOOK_MESSENGER]: {
    accent: "#ffb801",
    bg: "bg-amber-450",
    border: "hover:border-amber-450 focus-visible:border-amber-450",
    hover: "hover:text-amber-450",
    text: "text-amber-450",
    main: "#ffa904",
    caret: "caret-amber-450",
    buttonColor: ButtonColor.ORANGE
  },
  [Channel.WHATSAPP]: {
    accent: "#ffb801",
    bg: "bg-amber-450",
    border: "hover:border-amber-450 focus-visible:border-amber-450",
    hover: "hover:text-amber-450",
    main: "#ffa904",
    text: "text-amber-450",
    caret: "caret-amber-450",
    buttonColor: ButtonColor.ORANGE
  },
};

export enum SupportingButtonColors {
  WHITE = "white",
  YELLOW = "yellow",
  BLACK = "black",
  DARK_GREY = "darkGrey",
  RED = "red",
}

export const supportButtonStyles: Record<SupportingButtonColors, { main: string; accent: string }> = {
  [SupportingButtonColors.WHITE]: {
    main: "#ffffff",
    accent: "#f5f5f5",
  },
  [SupportingButtonColors.YELLOW]: {
    main: "#ffd41e",
    accent: "#ffb801",
  },
  [SupportingButtonColors.BLACK]: {
    main: "#323232",
    accent: "#1b1b1b",
  },
  [SupportingButtonColors.DARK_GREY]: {
    main: "#707070",
    accent: "#4b4b4b",
  },
  [SupportingButtonColors.RED]: {
    main: "#ff4b34",
    accent: "#e71b00",
  },
};

export function GetChannelFromParam(param?: string): Channel {
  return paramToChannelMap[param?.toLowerCase() ?? ""] ?? Channel.WEB;
}
